
(function () {
  "use strict";

  const STORAGE_KEY = "kandlia-theme";

  function getSavedTheme() {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved === "light" || saved === "dark") return saved;
    } catch (error) {}
    return document.body && document.body.getAttribute("data-theme") === "light" ? "light" : "dark";
  }

  function setTheme(theme) {
    const finalTheme = theme === "light" ? "light" : "dark";
    document.documentElement.setAttribute("data-theme", finalTheme);

    if (document.body) {
      document.body.setAttribute("data-theme", finalTheme);
      document.body.classList.toggle("is-light-mode", finalTheme === "light");
      document.body.classList.toggle("is-dark-mode", finalTheme === "dark");
    }

    try {
      localStorage.setItem(STORAGE_KEY, finalTheme);
    } catch (error) {}
  }

  function closeMenus() {
    document.querySelectorAll("[data-kl-header].is-open").forEach(function (header) {
      header.classList.remove("is-open");
      const toggle = header.querySelector("[data-menu-toggle]");
      if (toggle) toggle.setAttribute("aria-expanded", "false");
    });
  }

  function bindThemeButtons() {
    document.querySelectorAll("[data-theme-toggle]").forEach(function (button) {
      if (button.dataset.kandliaThemeReady === "true") return;
      button.dataset.kandliaThemeReady = "true";

      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        const current = document.body.getAttribute("data-theme") === "light" ? "light" : "dark";
        setTheme(current === "light" ? "dark" : "light");
      });
    });
  }

  function bindMenuButtons() {
    document.querySelectorAll("[data-kl-header]").forEach(function (header) {
      const toggle = header.querySelector("[data-menu-toggle]");
      const menu = header.querySelector("[data-expanded-menu]");

      if (!toggle || !menu || toggle.dataset.kandliaMenuReady === "true") return;
      toggle.dataset.kandliaMenuReady = "true";

      toggle.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();

        const nextState = !header.classList.contains("is-open");
        closeMenus();

        header.classList.toggle("is-open", nextState);
        toggle.setAttribute("aria-expanded", nextState ? "true" : "false");
      });

      menu.querySelectorAll("a").forEach(function (link) {
        link.addEventListener("click", function () {
          header.classList.remove("is-open");
          toggle.setAttribute("aria-expanded", "false");
        });
      });
    });
  }

  function initKandlia() {
    setTheme(getSavedTheme());
    bindThemeButtons();
    bindMenuButtons();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initKandlia);
  } else {
    initKandlia();
  }

  document.addEventListener("shopify:section:load", initKandlia);
  document.addEventListener("shopify:section:select", initKandlia);

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeMenus();
  });
})();
